module.exports = __webpack_public_path__ + "static/img/92070B_3_R_20200914_fit.53348a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92070B_3_R_20200914_fit.png
// module id = VLKz
// module chunks = 0